(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/collections/bomben-draws.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/collections/bomben-draws.js'); (function(Backbone, _, svs) {
  'use strict';

  svs.tipset.collections.BombenDraws = Backbone.Collection.extend({
    model: svs.tipset.models.BombenDraw,

    initialize: function() {
      if (
        svs.utils.ns.isNamespace('svs.tipset.data') &&
        svs.utils.ns.isNamespace('svs.tipset.data.bombenDraws')
      ) {
        this.set(svs.tipset.data.bombenDraws);
      }
    },

    getBombenDrawByDrawNumber: function(drawNumber) {
      return _.find(this.models, function(draw) {
        return draw.get('bombenRound') === drawNumber;
      });
    },

    getMatchesByDrawNumber: function(drawNumber) {
      var draw = this.getBombenDrawByDrawNumber(drawNumber);
      return draw ? draw.get('bombenMatch') : null;
    }
  });
})(Backbone, _, svs);

 })(window);